import EventEmitter from 'events'
const CONNECT_DELAY = 3e3

class SocketService extends EventEmitter {
  constructor () {
    super()
    this.ws = null
    this.reconnectTimer = null
    this.isOpened = false
    this.connect()
  }

  connect () {
    let query = new URLSearchParams(location.search)
    let wsLink = `ws://${query.get('ws_host') || '127.0.0.1'}:8233`
    this.ws = new WebSocket(wsLink)
    this.ws.addEventListener('open', () => {
      this.emit('open')
      this.isOpened = true
      this.ws.send(JSON.stringify({
        event: 'clientModuleName',
        clientModuleName: query.get('m')
      }))
    })
    this.ws.addEventListener('message', (evt) => {
      this.handleMessage(evt.data)
    })
    this.ws.addEventListener('close', () => {
      this.isOpened = false
      this.emit('close')
      this.reconnect()
    })
    this.ws.addEventListener('error', err => {
      console.log(`[SocketService Error]: ${err}`)
      this.isOpened = false
      this.emit('error')
      this.reconnect()
    })
  }

  disconnect () {
    if (this.ws && this.ws.readyState !== 3) {
      this.ws.close()
    }
    this.isOpened = false
    this.ws = null
  }

  reconnect () {
    clearTimeout(this.reconnectTimer)
    this.disconnect()
    this.reconnectTimer = setTimeout(() => {
      this.connect()
    }, CONNECT_DELAY)
  }

  opened () {
    if (this.isOpened) {
      return Promise.resolve()
    } else {
      return new Promise((resolve, reject) => {
        this.once('open', () => {
          resolve()
        })
      })
    }
  }

  handleMessage (msg) {
    let data = JSON.parse(msg)
    if (data.event && data.data) {
      this.emit(data.event, data.data)
    }
  }

  send (event, data) {
    this.ws.send(JSON.stringify({
      event,
      data
    }))
  }

  sendAcceptModuleNames (moduleNames) {
    this.ws.send(JSON.stringify({
      event: 'clientAcceptModuleNames',
      acceptModuleNames: moduleNames
    }))
  }
}

export default new SocketService()



// WEBPACK FOOTER //
// ./src/container/SocketService.js